import React, { useEffect, useState } from 'react';
import { Input, Button, Tag, Divider, Popconfirm, Switch, Card, Row, Table, Drawer, Col, Descriptions, Form, Select, DatePicker, Space } from 'antd';
import './pages-reports-reports-components-rm-receiving-report.css';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import {GrnService} from 'libs/shared-services/procurement/src/lib/grn-service'
import { RmReceivingReportReq } from '@gtpl/shared-models/procurement-management';
import {FallOutlined, InfoCircleFilled, RiseOutlined, UndoOutlined} from '@ant-design/icons'
import moment from 'moment';
import { BillTypeEnum, HarvestTypes } from '@gtpl/shared-models/common-models';
import dayjs from 'dayjs';
import html2pdf from 'html2pdf.js';
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import { PlantsDropDown } from '@gtpl/shared-models/masters';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { UnitcodeService } from '@gtpl/shared-services/masters';

export interface RmReceivingReportProps {}

export function RmReceivingReport(
  props: RmReceivingReportProps
) {
  
  const service = new GrnService()
  const [data, setData]=useState([])
  const [farmers, setFarmers]=useState([])
  const [agents, setAgents]=useState([])
  const [apDealers, setApDealers]=useState([])
  const [othersDealers, setOthersDealers]=useState([])
  const [ownPonds, setOwnPonds]=useState([])
  const [summaryData, setsummaryData]=useState([])
  const [dates, setDates]=useState([])
  const [rmRates, setRmRates]=useState([])
  const [totalFarmersQuantity, setTotalFarmersQuantity]=useState(0)
  const [totalApDealersQuantity, setTotalApDealersQuantity]=useState(0)
  const [totalAgentsQuantity, setTotalAgentsQuantity]=useState(0)
  const [totalOthersDealersQuantity, setTotalOthersDealersQuantity]=useState(0)
  const [totalOwnPondsQuantity, setTotalOwnPondsQuantity]=useState(0)
  const [total, setTotal]=useState(0)
 const [isVisible,setIsVisible] = useState(null)
 const [othersCount, setOthersCount]=useState([])
 const [dataLoaded, setDataLoaded] = useState(false);
 const [indentDates, setindentDates]=useState([]);
 const [hide, setHide] = useState(true);
    const { Option } = Select;
const [plantData, setPlantData] = useState<PlantsDropDown[]>([]);
  const unitsService = new UnitcodeService();
  const [unitId, setUnitId] = useState<number>(0);
 
  useEffect(()=>{
    if (Number(localStorage.getItem('unit_id')) != 5) {
      form.setFieldsValue({ unitId: Number(localStorage.getItem('unit_id')) })
      setUnitId(Number(localStorage.getItem('unit_id')))
    }
    getAllPlants()
  },[])

  const getAllPlants = () => {
    unitsService.getAllMainPlants().then((res) => {
        if (res.status) {
            setPlantData(res.data);
        } else {
            setPlantData([]);
        }
    }).catch(err => {
        AlertMessages.getErrorMessage(err.message);
        setPlantData([]);
    })
}
const handleUnit = (value) => {
  setUnitId(value)
}
  const [form] = Form.useForm();
  let totalDayReqQty =0
  let totalOpBal =0
  let totalDay1 =null
  let totalDay2 =null
  let totalDay3 =null
  let totalDay4 =null
  let totalDay5 =null
  let totalDay6 =null
  let totalDay7 =null
  let totalDay8 =null
  let totalDay9 =null
  let totalDay10 =null
  let totalDeviation =null
  let totalDeviationPercent =null


  let selectedTotal = 0
  let totalQty = 0
  let showDay1 = false 
  let showDay2 = false 
  let showDay3 = false 
  let showDay4 = false;
  let showDay5 = false 
  let showDay6 = false 
  let showDay7 = false 
  let showDay8 = false;
  let showDay9 = false 
  let showDay10 = false;
  // let totalFarmersQuantity =0
  // let totalAgentsQuantity =0
  // let totalApDealersQuantity =0
  // let totalOthersDealersQuantity =0
  // let totalOwnPondsQuantity =0
  // let total =0

  // useEffect(() => {
  //   getData();
  // }, []);
  const handleRowClick = (count)=>{
    // console.log(count,'countttttttttt');
    
    setIsVisible(isVisible === count? null:count)
    othersData()
  }
  const getData = async() =>{
    setIsVisible(null)
    const date = moment(form.getFieldValue('date')).format('YYYY-MM-DD')
    
    const req = new RmReceivingReportReq(date)
            req.unitId = unitId
    let uniqueIndentDates: string[] = []
    await service.getRmRecievingReportData(req).then((res)=>{
      if(res.status){
        const indentDates: string[] = [];
        setHide(true)
        setDataLoaded(true)
        setData(res.data)
        setFarmers (res.data.farmers)
        setAgents (res.data.agents)
        setApDealers (res.data.dealersAp)
        setOthersDealers (res.data.dealersOthers)
        setOwnPonds (res.data.ownPonds)
        setTotalFarmersQuantity( res.data.farmers.reduce((sum, item) => sum + Number(item.quantity), 0))
        console.log(res.data.farmers.reduce((sum, item) => sum + Number(item.quantity), 0),'total farmers')
        console.log(res.data.ownPonds.reduce((sum, item) => sum + Number(item.quantity), 0),'ppppppppppppp');
        setTotalAgentsQuantity(res.data.agents.reduce((sum, item) => sum + Number(item.quantity), 0))
        
        // console.log(res.data.farmers.agents((sum, item) => sum + Number(item.quantity), 0),'total agents')
        setTotalOwnPondsQuantity(res.data.ownPonds.reduce((sum, item) => sum + Number(item.quantity), 0))
        setTotalApDealersQuantity(res.data.dealersAp.reduce((sum, item) => sum + Number(item.quantity), 0))
        setTotalOthersDealersQuantity(res.data.dealersOthers.reduce((sum, item) => sum + Number(item.quantity), 0))
        const farmersAmt= res.data.farmers.reduce((sum, item) => sum + Number(item.amount) , 0)
        const agentsAmt= res.data.agents.reduce((sum, item) => sum + Number(item.amount), 0)
        const apDealersAmt= res.data.dealersAp.reduce((sum, item) => sum + Number(item.amount), 0)
        const otherDealesAmt= res.data.dealersOthers.reduce((sum, item) => sum + Number(item.amount), 0)
        const ownPondsAmt= res.data.ownPonds.reduce((sum, item) => sum + Number(item.amount), 0)

        // Map and push indent dates from each category
        res.data.farmers.map(farmer => indentDates.push(farmer.indentDate?moment(farmer.indentDate).format('YYYY-MM-DD'):null));
        res.data.agents.map(agent => indentDates.push(agent.indentDate?moment(agent.indentDate).format('YYYY-MM-DD'):null));
        res.data.ownPonds.map(other => indentDates.push(other.indentDate?moment(other.indentDate).format('YYYY-MM-DD'):null));
        res.data.dealersAp.map(other => indentDates.push(other.indentDate?moment(other.indentDate).format('YYYY-MM-DD'):null));
        res.data.dealersOthers.map(other => indentDates.push(other.indentDate?moment(other.indentDate).format('YYYY-MM-DD'):null));
        // console.log(indentDates,'oooooooooooooo');
        
         uniqueIndentDates = [...new Set(indentDates)];

        // console.log(uniqueIndentDates, 'After Removing Duplicates');
        
        setindentDates(uniqueIndentDates);      //   setTotal(res.data.farmers.reduce((sum, item) => total + Number(item.amount) , 0))
      //   // console.log(total,totalFarmersQuantity,'oooooooooo');
      //   setTotal(res.data.agents.reduce((sum, item) => total + Number(item.amount), 0))
      //   // console.log(total,totalAgentsQuantity,'jjjjjjjjjjj');
      //   setTotal(res.data.dealersAp.reduce((sum, item) => total + Number(item.amount), 0))
      //   setTotal(res.data.ownPonds.reduce((sum, item) => total + Number(item.amount), 0))
      //   // console.log(total,totalApDealersQuantity,'eeeeeeeeeee');
      //  setTotal(res.data.dealersOthers.reduce((sum, item) => total + Number(item.amount), 0))
        // console.log(total,totalOthersDealersQuantity,'wwwwwwwwwwwww');
      //   console.log(total,totalOwnPondsQuantity,'qqqqqqqqqqqqqqqqq');
      setTotal(Number(farmersAmt)+Number(agentsAmt)+Number(otherDealesAmt)+Number(apDealersAmt)+Number(ownPondsAmt))
      service.getRmRates(uniqueIndentDates).then((res)=>{
        if(res.status){
          setRmRates(res.data)
        }
      })
      }else{
        setDataLoaded(true)

        setFarmers ([])
        setAgents ([])
        setApDealers ([])
        setOthersDealers ([])
        setOwnPonds ([])
      }
    })
    // service.getRmRecievingReportSummary(req).then((res)=>{
    //   if(res.status){
    //     setsummaryData(res.data)
    //     setDates(res.data1)
    //   }
    // })
  
  }
  const onReset = () => {
    form.resetFields();
    setData([]);
    setFarmers([]);
    setAgents([]);
    setApDealers([]);
    setOthersDealers([]);
    setOwnPonds([]);
    setTotalFarmersQuantity(0);
    setTotalAgentsQuantity(0);
    setTotalOwnPondsQuantity(0);
    setTotalApDealersQuantity(0);
    setTotalOthersDealersQuantity(0);
    setTotal(0);
    setDates([]);
    setRmRates([]);
   
  }
  const onSearch = () => {
    getData()
  }
  // console.log(totalFarmersQuantity,'loggggggggg');
  const [daysInMonth, setDaysInMonth] = useState<number | null>(null);

  const onDateChange = (val) => {
    
    if (val) {
      const date = moment(val); // Convert to Moment.js object
      const days = date.daysInMonth();
      setDaysInMonth(days)
    } else {
      setDaysInMonth(0)
    }
    
  };
  const othersData = () =>{
    const date = moment(form.getFieldValue('date')).format('YYYY-MM-DD')

    const req = new RmReceivingReportReq(date)
service.getRmRecievingReportOthersSummary(req).then((res)=>{
  if(res.status){
    setOthersCount(res.data)
  }else{
    setOthersCount([])
  }
})
  }

const generatePDF = () => {
  setHide(false);

  setTimeout(() => {
      const pdfContent = document.createElement('div');

      const tableElement1 = document.getElementById("table1");
      const tableElement2 = document.getElementById("table2"); 

      if (!tableElement1 || !tableElement2) {
          console.error("One or both table elements not found!");
          setHide(true);
          return;
      }

      const clonedTable1 = tableElement1.cloneNode(true);
      const clonedTable2 = tableElement2.cloneNode(true);
      const tableWrapper1 = document.createElement("div");
      tableWrapper1.appendChild(clonedTable1);
      const pageBreak = document.createElement("div");
      pageBreak.style.pageBreakBefore = "always"; 
      const tableWrapper2 = document.createElement("div");
      tableWrapper2.appendChild(clonedTable2);
      pdfContent.appendChild(tableWrapper1);
      pdfContent.appendChild(pageBreak);
      pdfContent.appendChild(tableWrapper2);
      const style = document.createElement('style');
      style.textContent = `
          table {
              width: 100%;
              border-collapse: collapse;
          }
          tr, td, th {
              page-break-inside: avoid;
              break-inside: avoid;
              font-size: 20px;
          }
      `;
      pdfContent.appendChild(style);

      const options = {
        filename: 'RM Receiving Report',
        image: { type: 'jpeg', quality: 0.9 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'mm', format: [594, 350], orientation: 'landscape' },
    };
    
    

      html2pdf()
          .from(pdfContent)
          .set(options)
          .save()
          .then(() => {
              pdfContent.remove();
              setHide(true);
          });
  }, 50);
};



  console.log(hide,'ppppppppp');
  
  return (
    <>
    <Card  title={<span style={{color:'white', textAlign:'center'}}>RAW MATERIAL RECEIVING REPORT</span>}
    style={{textAlign:'center'}} headStyle={{backgroundColor: '#69c0ff', border: 0 }} extra={data.length == 0 ||(<><ReactHTMLTableToExcel
      id='excel-button'
      // className='download-table-xls-button'
      table='rm-receiving-table'
      filename='Rm Receiveing Report'
      sheet="Sheet 1"
      buttonText='Get Excel'
     justify='end'
     className="ant-btn ant-btn"
      /><Button
      type="primary"
      onClick={generatePDF}
      style={{ marginLeft: 10 }}
    >
      Download PDF
    </Button></>)}>
      <Form form={form} layout='vertical'>
                <Row >
                    <Col span={4} style={{paddingRight:'10px'}}>
                    <Form.Item label='Re Weighment Date' name='date'>
                    <DatePicker style={{width:'100%'}} onChange={(e)=>onDateChange(e)}/>
                    </Form.Item>
                    </Col>  
                    <Col span={6}>
        <Form.Item name="unitId"   label="Unit" rules={[{ required: false,message: 'Missing Unit' }]} >
               <Select
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                    placeholder="Select Unit"
                    allowClear
                    style={{ width: '100%' }}
                    onChange={handleUnit}
                    disabled={Number(localStorage.getItem('unit_id')) != 5 ? true : false}
                >
                    {plantData.map(dropData => {
                        return <Option value={dropData.plantId}>{dropData.plantCode}</Option>
                    })}
                </Select>
            </Form.Item>
          
        </Col>

                   <Col span={6} style={{ marginTop: '30px' }}>
  <Space >
    <Form.Item>
      <Button onClick={onSearch} type="primary">Get Report</Button>
    </Form.Item>
    <Form.Item>
      <Button icon={<UndoOutlined />}  onClick={onReset}>Reset</Button>
    </Form.Item>
  </Space>
</Col>
                </Row>
                
                
            </Form>
            {(dataLoaded && (farmers?.length > 0 || agents?.length > 0 || apDealers?.length > 0 || othersDealers?.length > 0 || ownPonds?.length > 0)) ? (
 <>
 <table id='rm-receiving-table' width='max-content'>
            <Card size='small'>

              <Row gutter={[24, 24]} style={{ display: 'flex', flexWrap: 'nowrap' }}>
                <Col span={18} style={{ width: 'max-content', flex: '1' }}>
                  <table>
                    <tr style={{ background: '#E5D9FF' }}><th className='ta-b' colSpan={13} style={{ textAlign: 'center' }}>{moment(form.getFieldValue('date')).format('YYYY-MM-DD')}</th></tr>
                    <tr style={{ background: '#E5D9FF' }}><th className='ta-b' colSpan={13} style={{ textAlign: 'center' }}>Raw material receiving report</th></tr>
                    <tr style={{ background: '#FFEBD9', textAlign: 'center' }}>
                      <th className='ta-h'>Farmer Name</th>
                      <th className='ta-h'>Financier</th>
                      <th className='ta-h'>Batch No</th>
                      <th className='ta-h'>Place</th>
                      <th className='ta-h'>Count</th>
                      <th className='ta-h'>Purchase/Plant Weight</th>
                      <th className='ta-h'>Rate</th>
                      <th className='ta-h'>Transport</th>
                      <th className='ta-h'>Amount</th>
                      <th className='ta-h'>Remarks</th>
                      <th className='ta-h'>Harvest</th>
                      <th className='ta-h'>Supervisor</th>
                      <th className='ta-h'>Indent Date</th>


                    </tr>
                    <tr style={{ background: '#FFEBD9', textAlign: 'center' }}>
                      <th className='ta-b' colSpan={13}>Farmers</th>
                    </tr>
                    {farmers.length > 0 ? (
                      <>{farmers.map((e) => {
                        return (
                          <tr>
                            <td className='ta-b'>{e.name ? e.name : '-'}</td>
                            <td className='ta-b'>{e.financier != null ? e.financier : '-'}
                              {/* (<span style={{color:e.billType=='Farmer'?'red':'orange'}}>{e.billType}</span>) */}
                            </td>
                            <td className='ta-b'>{e.batchNo ? e.batchNo : '-'}</td>
                            <td className='ta-b'>{e.city ? e.city : '-'}</td>
                            <td className='ta-b'>{e.count ? e.count : '-'}{e.defect != null ? `(${e.defect})` : null}</td>
                            <td className='ta-bb'>{e.quantity}</td>
                            <td className='ta-bb'>{Number(e.rate) > 0
    ? (e.harvest === HarvestTypes.Re_Weighment 
        ? (Number(e.rate) - Number(e.transport ? e.transport : 0)) 
        : (Number(e.rate) - Number(e.commission ? e.commission : 0)))
    : 0}</td>
                            <td className='ta-bb'>{e.harvest === HarvestTypes.Re_Weighment ? (Number(e.transport ? e.transport : 0)) : (e.commission ? e.commission : 0)}</td>
                            <td className='ta-bb'>{Number(e.amount).toFixed(2)}</td>
                            <td className='ta-b'></td>
                            <td className='ta-b'>{e.harvest ? e.harvest : '-'}</td>
                            <td className='ta-b'>{e.supervisor ? e.supervisor : '-'}</td>
                            <td className='ta-b'>{e.indentDate ? moment(e.indentDate).format('DD-MM-YYYY') : '-'}</td>

                          </tr>
                        );
                      })}</>
                    ) : ''}
                    <tr>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'>Total</td>
                      <td className='ta-bb'>{Number(totalFarmersQuantity).toFixed(2)}</td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>


                    </tr>
                    <tr style={{ background: '#FFEBD9', textAlign: 'center' }}>
                      <th className='ta-b' colSpan={13}>Agents</th>
                    </tr>
                    {agents?.length > 0 ? (
                      <>{agents.map((e) => {
                        return (
                          <tr>
                            <td className='ta-b'>{e.name ? e.name : '-'}</td>
                            <td className='ta-b'>{e.financier != null ? e.financier : '-'}
                              {/* (<span style={{color:e.billType=='Farmer'?'red':'orange'}}>{e.billType}</span>) */}
                            </td>
                            <td className='ta-b'>{e.batchNo ? e.batchNo : '-'}</td>
                            <td className='ta-b'>{e.city ? e.city : '-'}</td>
                            <td className='ta-b'>{e.count ? e.count : '-'}{e.defect != null ? `(${e.defect})` : null}</td>
                            <td className='ta-bb'>{e.quantity}</td>
                            <td className='ta-bb'>{Number(e.rate) > 0
    ? (e.harvest === HarvestTypes.Re_Weighment 
        ? (Number(e.rate) - Number(e.transport ? e.transport : 0)) 
        : (Number(e.rate) - Number(e.commission ? e.commission : 0)))
    : 0}</td>
                            <td className='ta-bb'>{e.harvest === HarvestTypes.Re_Weighment ? (Number(e.transport ? e.transport : 0)) : (e.commission ? e.commission : 0)}</td>
                            <td className='ta-bb'>{Number(e.amount).toFixed(2)}</td>
                            <td className='ta-b'></td>
                            <td className='ta-b'>{e.harvest ? e.harvest : '-'}</td>
                            <td className='ta-b'>{e.supervisor ? e.supervisor : '-'}</td>
                            <td className='ta-b'>{e.indentDate ? moment(e.indentDate).format('DD-MM-YYYY') : '-'}</td>


                          </tr>
                        );
                      })}</>
                    ) : ''}
                    <tr>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'>Total</td>
                      <td className='ta-bb'>{Number(totalAgentsQuantity).toFixed(2)}</td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>

                    </tr>
                    <tr style={{ background: '#FFEBD9', textAlign: 'center' }}>
                      <th className='ta-b' colSpan={13}>Feed/Seed Dealers From Ap</th>
                    </tr>
                    {apDealers?.length > 0 ? (
                      <>{apDealers.map((e) => {
                        return (
                          <tr>
                            <td className='ta-b'>{e.name ? e.name : '-'}</td>
                            <td className='ta-b'>{e.financier != null ? e.financier : '-'}
                              {/* (<span style={{color:e.billType=='Farmer'?'red':'orange'}}>{e.billType}</span>) */}
                            </td>
                            <td className='ta-b'>{e.batchNo ? e.batchNo : '-'}</td>
                            <td className='ta-b'>{e.city ? e.city : '-'}</td>
                            <td className='ta-b'>{e.count ? e.count : '-'}{e.defect != null ? `(${e.defect})` : null}</td>
                            <td className='ta-bb'>{e.quantity}</td>
                            <td className='ta-bb'>{Number(e.rate) > 0
    ? (e.harvest === HarvestTypes.Re_Weighment 
        ? (Number(e.rate) - Number(e.transport ? e.transport : 0)) 
        : (Number(e.rate) - Number(e.commission ? e.commission : 0)))
    : 0}</td>
                            <td className='ta-bb'>{e.harvest === HarvestTypes.Re_Weighment ? (Number(e.transport ? e.transport : 0)) : (e.commission ? e.commission : 0)}</td>
                            <td className='ta-bb'>{Number(e.amount).toFixed(2)}</td>
                            {/* <td className='ta-bb'>{(Number(e.harvest=== HarvestTypes.Re_Weighment?(Number(e.rate)-Number(e.transport?e.transport:0)):(Number(e.rate)-Number(e.commission?e.commission:0)))*Number(e.quantity)).toFixed(2)}</td> */}

                            <td className='ta-b'></td>
                            <td className='ta-b'>{e.harvest ? e.harvest : '-'}</td>
                            <td className='ta-b'>{e.supervisor ? e.supervisor : '-'}</td>
                            <td className='ta-b'>{e.indentDate ? moment(e.indentDate).format('DD-MM-YYYY') : '-'}</td>


                          </tr>
                        );
                      })}</>
                    ) : ''}
                    <tr>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'>Total</td>
                      <td className='ta-bb'>{Number(totalApDealersQuantity).toFixed(2)}</td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>

                    </tr>
                    <tr style={{ background: '#FFEBD9', textAlign: 'center' }}>
                      <th className='ta-b' colSpan={13}>Feed/Seed Dealers From Orissa/West Bengal</th>
                    </tr>
                    {othersDealers?.length > 0 ? (
                      <>{othersDealers.map((e) => {
                        return (
                          <tr>
                            <td className='ta-b'>{e.name ? e.name : '-'}</td>
                            <td className='ta-b'>{e.financier != null ? e.financier : '-'}
                              {/* (<span style={{color:e.billType=='Farmer'?'red':'orange'}}>{e.billType}</span>) */}
                            </td>
                            <td className='ta-b'>{e.batchNo ? e.batchNo : '-'}</td>
                            <td className='ta-b'>{e.city ? e.city : '-'}</td>
                            <td className='ta-b'>{e.count ? e.count : '-'}{e.defect != null ? `(${e.defect})` : null}</td>
                            <td className='ta-bb'>{e.quantity}</td>
                            <td className='ta-bb'>{Number(e.rate) > 0
    ? (e.harvest === HarvestTypes.Re_Weighment 
        ? (Number(e.rate) - Number(e.transport ? e.transport : 0)) 
        : (Number(e.rate) - Number(e.commission ? e.commission : 0)))
    : 0}</td>
                            <td className='ta-bb'>{e.harvest === HarvestTypes.Re_Weighment ? (Number(e.transport ? e.transport : 0)) : (e.commission ? e.commission : 0)}</td>
                            <td className='ta-bb'>{Number(e.amount)}</td>
                            <td className='ta-b'></td>
                            <td className='ta-b'>{e.harvest ? e.harvest : '-'}</td>
                            <td className='ta-b'>{e.supervisor ? e.supervisor : '-'}</td>
                            <td className='ta-b'>{e.indentDate ? moment(e.indentDate).format('DD-MM-YYYY') : '-'}</td>


                          </tr>
                        );
                      })}</>
                    ) : ''}
                    <tr>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'>Total</td>
                      <td className='ta-bb'>{Number(totalOthersDealersQuantity).toFixed(2)}</td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>

                    </tr>
                    <tr style={{ background: '#FFEBD9', textAlign: 'center' }}>
                      <th className='ta-b' colSpan={13}>Own Ponds</th>
                    </tr>
                    {ownPonds?.length > 0 ? (
                      <>{ownPonds.map((e) => {
                        return (
                          <tr>
                            <td className='ta-b'>{e.name ? e.name : '-'}</td>
                            <td className='ta-b'>{e.financier != null ? e.financier : '-'}
                              {/* (<span style={{color:e.billType=='Farmer'?'red':'orange'}}>{e.billType}</span>) */}
                            </td>
                            <td className='ta-b'>{e.batchNo ? e.batchNo : '-'}</td>
                            <td className='ta-b'>{e.city ? e.city : '-'}</td>
                            <td className='ta-b'>{e.count ? e.count : '-'}{e.defect != null ? `(${e.defect})` : null}</td>
                            <td className='ta-b'>{e.quantity}</td>
                            <td className='ta-b'>{Number(e.rate) > 0
    ? (e.harvest === HarvestTypes.Re_Weighment 
        ? (Number(e.rate) - Number(e.transport ? e.transport : 0)) 
        : (Number(e.rate) - Number(e.commission ? e.commission : 0)))
    : 0}</td>
                            <td className='ta-b'>0</td>
                            <td className='ta-b'>{Number(e.amount)}</td>   
                            <td className='ta-b'></td>
                            <td className='ta-b'>{e.harvest ? e.harvest : '-'}</td>
                            <td className='ta-b'>{e.supervisor ? e.supervisor : '-'}</td>
                            <td className='ta-b'>{e.indentDate ? moment(e.indentDate).format('DD-MM-YYYY') : '-'}</td>

                          </tr>
                        );
                      })}</>
                    ) : ''}
                    <tr>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'>Total</td>
                      <td className='ta-bb'>{Number(totalOwnPondsQuantity).toFixed(2)}</td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>

                    </tr>
                    <tr>
                      <td className='ta-b'></td>
                      <td className='ta-b' colSpan={4}>Total</td>
                      <td className='ta-bb'>{Number(totalAgentsQuantity + totalApDealersQuantity + totalFarmersQuantity + totalOthersDealersQuantity + totalOwnPondsQuantity).toFixed(2)}</td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-bb'>{total ? Number(total).toFixed(2) : '-'}</td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>


                    </tr>
                  </table>
                </Col>
                <Col span={6} style={{ width: 'max-content', gap: '10px', flex: '1' }}>
                  <Row gutter={18} style={{ display: 'flex', flexWrap: 'nowrap' }}>
                    {rmRates?.map((rec, idx) => {
                      return (
                        // <div key={idx} style={{ flex: '1', minWidth: '250px' }}>
                        <Col span={6} style={{ gap: '20px', marginLeft: '10%' }}>

                          <table key={idx} style={{ marginBottom: "20px", borderCollapse: "collapse" }}>
                            <thead>
                              <tr>
                                <th className="ta-b" colSpan={3}>Ap RM Rates ({rec.date} to {rec.effectedDate})</th>
                              </tr>
                              <tr>
                                <th className="ta-b">Count</th>
                                <th className="ta-b">Live Rate</th>
                                <th className="ta-b">R/W Rate</th>
                              </tr>
                            </thead>
                            <tbody>
                              {rec.rates.map((rate, i) => (
                                <tr key={i} style={{ backgroundColor: rate.colorVar ? 'lightblue' : '' }}>
                                  <td className="ta-b">{rate.count ? rate.count : '-'}</td>
                                  <td className="ta-b" style={{ textAlign: "right" }}>{rate.lhPrice ? rate.lhPrice : '-'}</td>
                                  <td className="ta-b" style={{ textAlign: "right" }}>{rate.rwPrice ? rate.rwPrice : '-'}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </Col>

                        // </div>
                      );

                    })}
                  </Row>



                </Col>
              </Row>
              <br />
              {/* <table className={'ta-b'} style={{ width: '100%', tableLayout: 'fixed' }}>
<tr style={{backgroundColor:'#ffba08'}}>
  <th className={'ta-b'}>Count</th>
  {summaryData?.map((res, index) => (
    <th key={index} className={'ta-b'}>{res.Date}</th>
  ))}
</tr>

{Array.from(new Set(summaryData?.reduce((acc, val) => acc.concat(val.data?.map(e => e.count)), [])))?.map((count, countIndex) => (
  <tr key={countIndex}>
    <td className={'ta-b'}>{count}</td>
    {summaryData?.map((company, companyIndex) => (
      <td key={companyIndex} className={'ta-b'}>
        {company.data.find(item => item.count === count)?.qty || '-'}
      </td>
    ))}
  </tr>
))}
</table> */}


            </Card>
          </table>
          {hide === false && (
          
<>

<table id='table1' width='max-content' >
<Card>
<Row gutter={[24, 24]} style={{ display: 'flex', flexWrap: 'wrap' }}>
                  <Col span={24} style={{ width: 'max-content', flex: '1' }}>
                  <table>
                    <tr style={{ background: '#E5D9FF' }}><th className='ta-b' colSpan={13} style={{ textAlign: 'center' }}>{moment(form.getFieldValue('date')).format('YYYY-MM-DD')}</th></tr>
                    <tr style={{ background: '#E5D9FF' }}><th className='ta-b' colSpan={13} style={{ textAlign: 'center' }}>Raw material receiving report</th></tr>
                    <tr style={{ background: '#FFEBD9', textAlign: 'center' }}>
                      <th className='ta-h'>Farmer Name</th>
                      <th className='ta-h'>Financier</th>
                      <th className='ta-h'>Batch No</th>
                      <th className='ta-h'>Place</th>
                      <th className='ta-h'>Count</th>
                      <th className='ta-h'>Purchase/Plant Weight</th>
                      <th className='ta-h'>Rate</th>
                      <th className='ta-h'>Transport</th>
                      <th className='ta-h'>Amount</th>
                      <th className='ta-h'>Remarks</th>
                      <th className='ta-h'>Harvest</th>
                      <th className='ta-h'>Supervisor</th>
                      <th className='ta-h'>Indent Date</th>


                    </tr>
                    <tr style={{ background: '#FFEBD9', textAlign: 'center' }}>
                      <th className='ta-b' colSpan={13}>Farmers</th>
                    </tr>
                    {farmers.length > 0 ? (
                      <>{farmers.map((e) => {
                        return (
                          <tr>
                            <td className='ta-b'>{e.name ? e.name : '-'}</td>
                            <td className='ta-b'>{e.financier != null ? e.financier : '-'}
                              {/* (<span style={{color:e.billType=='Farmer'?'red':'orange'}}>{e.billType}</span>) */}
                            </td>
                            <td className='ta-b'>{e.batchNo ? e.batchNo : '-'}</td>
                            <td className='ta-b'>{e.city ? e.city : '-'}</td>
                            <td className='ta-b'>{e.count ? e.count : '-'}{e.defect != null ? `(${e.defect})` : null}</td>
                            <td className='ta-bb'>{e.quantity}</td>
                            <td className='ta-bb'>{Number(e.rate) > 0
    ? (e.harvest === HarvestTypes.Re_Weighment 
        ? (Number(e.rate) - Number(e.transport ? e.transport : 0)) 
        : (Number(e.rate) - Number(e.commission ? e.commission : 0)))
    : 0}</td>
                            <td className='ta-bb'>{e.harvest === HarvestTypes.Re_Weighment ? (Number(e.transport ? e.transport : 0)) : (e.commission ? e.commission : 0)}</td>
                            <td className='ta-bb'>{Number(e.amount).toFixed(2)}</td>
                            <td className='ta-b'></td>
                            <td className='ta-b'>{e.harvest ? e.harvest : '-'}</td>
                            <td className='ta-b'>{e.supervisor ? e.supervisor : '-'}</td>
                            <td className='ta-b'>{e.indentDate ? moment(e.indentDate).format('DD-MM-YYYY') : '-'}</td>

                          </tr>
                        );
                      })}</>
                    ) : ''}
                    <tr>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'>Total</td>
                      <td className='ta-bb'>{Number(totalFarmersQuantity).toFixed(2)}</td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>


                    </tr>
                    <tr style={{ background: '#FFEBD9', textAlign: 'center' }}>
                      <th className='ta-b' colSpan={13}>Agents</th>
                    </tr>
                    {agents?.length > 0 ? (
                      <>{agents.map((e) => {
                        return (
                          <tr>
                            <td className='ta-b'>{e.name ? e.name : '-'}</td>
                            <td className='ta-b'>{e.financier != null ? e.financier : '-'}
                              {/* (<span style={{color:e.billType=='Farmer'?'red':'orange'}}>{e.billType}</span>) */}
                            </td>
                            <td className='ta-b'>{e.batchNo ? e.batchNo : '-'}</td>
                            <td className='ta-b'>{e.city ? e.city : '-'}</td>
                            <td className='ta-b'>{e.count ? e.count : '-'}{e.defect != null ? `(${e.defect})` : null}</td>
                            <td className='ta-bb'>{e.quantity}</td>
                            <td className='ta-bb'>{Number(e.rate) > 0
    ? (e.harvest === HarvestTypes.Re_Weighment 
        ? (Number(e.rate) - Number(e.transport ? e.transport : 0)) 
        : (Number(e.rate) - Number(e.commission ? e.commission : 0)))
    : 0}</td>
                            <td className='ta-bb'>{e.harvest === HarvestTypes.Re_Weighment ? (Number(e.transport ? e.transport : 0)) : (e.commission ? e.commission : 0)}</td>
                            <td className='ta-bb'>{Number(e.amount).toFixed(2)}</td>
                            <td className='ta-b'></td>
                            <td className='ta-b'>{e.harvest ? e.harvest : '-'}</td>
                            <td className='ta-b'>{e.supervisor ? e.supervisor : '-'}</td>
                            <td className='ta-b'>{e.indentDate ? moment(e.indentDate).format('DD-MM-YYYY') : '-'}</td>


                          </tr>
                        );
                      })}</>
                    ) : ''}
                    <tr>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'>Total</td>
                      <td className='ta-bb'>{Number(totalAgentsQuantity).toFixed(2)}</td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>

                    </tr>
                    <tr style={{ background: '#FFEBD9', textAlign: 'center' }}>
                      <th className='ta-b' colSpan={13}>Feed/Seed Dealers From Ap</th>
                    </tr>
                    {apDealers?.length > 0 ? (
                      <>{apDealers.map((e) => {
                        return (
                          <tr>
                            <td className='ta-b'>{e.name ? e.name : '-'}</td>
                            <td className='ta-b'>{e.financier != null ? e.financier : '-'}
                              {/* (<span style={{color:e.billType=='Farmer'?'red':'orange'}}>{e.billType}</span>) */}
                            </td>
                            <td className='ta-b'>{e.batchNo ? e.batchNo : '-'}</td>
                            <td className='ta-b'>{e.city ? e.city : '-'}</td>
                            <td className='ta-b'>{e.count ? e.count : '-'}{e.defect != null ? `(${e.defect})` : null}</td>
                            <td className='ta-bb'>{e.quantity}</td>
                            <td className='ta-bb'>{Number(e.rate) > 0
                            ? (e.harvest === HarvestTypes.Re_Weighment 
                                ? (Number(e.rate) - Number(e.transport ? e.transport : 0)) 
                                : (Number(e.rate) - Number(e.commission ? e.commission : 0)))
                            : 0}</td>
                            <td className='ta-bb'>{e.harvest === HarvestTypes.Re_Weighment ? (Number(e.transport ? e.transport : 0)) : (e.commission ? e.commission : 0)}</td>
                            <td className='ta-bb'>{Number(e.amount).toFixed(2)}</td>
                            {/* <td className='ta-bb'>{(Number(e.harvest=== HarvestTypes.Re_Weighment?(Number(e.rate)-Number(e.transport?e.transport:0)):(Number(e.rate)-Number(e.commission?e.commission:0)))*Number(e.quantity)).toFixed(2)}</td> */}

                            <td className='ta-b'></td>
                            <td className='ta-b'>{e.harvest ? e.harvest : '-'}</td>
                            <td className='ta-b'>{e.supervisor ? e.supervisor : '-'}</td>
                            <td className='ta-b'>{e.indentDate ? moment(e.indentDate).format('DD-MM-YYYY') : '-'}</td>


                          </tr>
                        );
                      })}</>
                    ) : ''}
                    <tr>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'>Total</td>
                      <td className='ta-bb'>{Number(totalApDealersQuantity).toFixed(2)}</td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>

                    </tr>
                    <tr style={{ background: '#FFEBD9', textAlign: 'center' }}>
                      <th className='ta-b' colSpan={13}>Feed/Seed Dealers From Orissa/West Bengal</th>
                    </tr>
                    {othersDealers?.length > 0 ? (
                      <>{othersDealers.map((e) => {
                        return (
                          <tr>
                            <td className='ta-b'>{e.name ? e.name : '-'}</td>
                            <td className='ta-b'>{e.financier != null ? e.financier : '-'}
                              {/* (<span style={{color:e.billType=='Farmer'?'red':'orange'}}>{e.billType}</span>) */}
                            </td>
                            <td className='ta-b'>{e.batchNo ? e.batchNo : '-'}</td>
                            <td className='ta-b'>{e.city ? e.city : '-'}</td>
                            <td className='ta-b'>{e.count ? e.count : '-'}{e.defect != null ? `(${e.defect})` : null}</td>
                            <td className='ta-bb'>{e.quantity}</td>
                            <td className='ta-bb'>{Number(e.rate) > 0
                            ? (e.harvest === HarvestTypes.Re_Weighment 
                                ? (Number(e.rate) - Number(e.transport ? e.transport : 0)) 
                                : (Number(e.rate) - Number(e.commission ? e.commission : 0)))
                            : 0}</td>
                            <td className='ta-bb'>{e.harvest === HarvestTypes.Re_Weighment ? (Number(e.transport ? e.transport : 0)) : (e.commission ? e.commission : 0)}</td>
                            <td className='ta-bb'>{Number(e.amount)}</td>
                            <td className='ta-b'></td>
                            <td className='ta-b'>{e.harvest ? e.harvest : '-'}</td>
                            <td className='ta-b'>{e.supervisor ? e.supervisor : '-'}</td>
                            <td className='ta-b'>{e.indentDate ? moment(e.indentDate).format('DD-MM-YYYY') : '-'}</td>


                          </tr>
                        );
                      })}</>
                    ) : ''}
                    <tr>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'>Total</td>
                      <td className='ta-bb'>{Number(totalOthersDealersQuantity).toFixed(2)}</td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>

                    </tr>
                    <tr style={{ background: '#FFEBD9', textAlign: 'center' }}>
                      <th className='ta-b' colSpan={13}>Own Ponds</th>
                    </tr>
                    {ownPonds?.length > 0 ? (
                      <>{ownPonds.map((e) => {
                        return (
                          <tr>
                            <td className='ta-b'>{e.name ? e.name : '-'}</td>
                            <td className='ta-b'>{e.financier != null ? e.financier : '-'}
                              {/* (<span style={{color:e.billType=='Farmer'?'red':'orange'}}>{e.billType}</span>) */}
                            </td>
                            <td className='ta-b'>{e.batchNo ? e.batchNo : '-'}</td>
                            <td className='ta-b'>{e.city ? e.city : '-'}</td>
                            <td className='ta-b'>{e.count ? e.count : '-'}{e.defect != null ? `(${e.defect})` : null}</td>
                            <td className='ta-bb'>{e.quantity}</td>
                            <td className='ta-bb'>
  {Number(e.rate) > 0
    ? (e.harvest === HarvestTypes.Re_Weighment 
        ? (Number(e.rate) - Number(e.transport || 0)) 
        : (Number(e.rate) - Number(e.commission || 0)))
    : 0}
</td>
                            <td className='ta-bb'>0</td>
                            {/* <td className='ta-bb'>{Number(e.amount)}</td> */}
                            <td className='ta-bb'>{(Number(e.rate) * Number(e.quantity)).toFixed(2)}</td>
                            <td className='ta-b'></td>
                            <td className='ta-b'>{e.harvest ? e.harvest : '-'}</td>
                            <td className='ta-b'>{e.supervisor ? e.supervisor : '-'}</td>
                            <td className='ta-b'>{e.indentDate ? moment(e.indentDate).format('DD-MM-YYYY') : '-'}</td>

                          </tr>
                        );
                      })}</>
                    ) : ''}
                    <tr>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'>Total</td>
                      <td className='ta-bb'>{Number(totalOwnPondsQuantity).toFixed(2)}</td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>

                    </tr>
                    <tr>
                      <td className='ta-b'></td>
                      <td className='ta-b' colSpan={4}>Total</td>
                      <td className='ta-bb'>{Number(totalAgentsQuantity + totalApDealersQuantity + totalFarmersQuantity + totalOthersDealersQuantity + totalOwnPondsQuantity).toFixed(2)}</td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-bb'>{total ? Number(total).toFixed(2) : '-'}</td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>
                      <td className='ta-b'></td>


                    </tr>
                  </table>
                </Col></Row>
                  </Card>
                  
</table>
<table id='table2'>
 <Card>
<Col
span={24}
style={{
  display: "flex",
  flexWrap: "wrap",
  gap: "20px",
  justifyContent: "center",
}}
>
{rmRates?.map((rec, idx) => {
  const chunkedRates = [];
  for (let i = 0; i < rec.rates.length; i += 35) {
    chunkedRates.push(rec.rates.slice(i, i + 35));
  }

  return (
    <Row
      key={idx}
      gutter={[24, 24]}
      style={{ display: "flex", flexWrap: "nowrap" }}
    >
      {chunkedRates.map((chunk, chunkIdx) => (
        <Col key={chunkIdx} style={{ marginLeft: "10px" }}>
          <table style={{ marginBottom: "20px", borderCollapse: "collapse", width: "100%", border: "1px solid #000" }} >
            {/* Always Render Table Header */}
            <thead>
              <tr>
                <th className="ta-b" colSpan={3} style={{ textAlign: "center" }}>
                  Ap RM Rates ({rec.date}) 
                </th>
              </tr>
              <tr>
                <th className="ta-b">Count</th>
                <th className="ta-b">Live Rate</th>
                <th className="ta-b">R/W Rate</th>
              </tr>
            </thead>
            <tbody>
              {chunk.map((rate, i) => (
                <tr
                  key={i}
                  style={{
                    backgroundColor: rate.colorVar ? "lightblue" : "",
                    borderBottom: "1px solid #ddd",
                  }}
                >
                  <td className="ta-b">{rate.count ? rate.count : "-"}</td>
                  <td className="ta-b" style={{ textAlign: "right" }}>
                    {rate.lhPrice ? rate.lhPrice : "-"}
                  </td>
                  <td className="ta-b" style={{ textAlign: "right" }}>
                    {rate.rwPrice ? rate.rwPrice : "-"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Col>
      ))}
    </Row>
  );
})}
</Col></Card> 

</table></>
             )}   
            </>
):(dataLoaded ? 'No Invoice Done In This Date' : null)}
    </Card>
    </>
  );
}

export default RmReceivingReport;
